import { AdminEditorService } from '../../admin.service';
import { FormSectionHandler } from '../entity.handler';
import { AssetDevice, AssetResponse, AssetUpdateRequest } from '@key-telematics/fleet-api-client';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { TextField } from '../utils';

interface SectionValues {
    [key: string]: string;
}

export class LinkedDevicesSectionHandler implements FormSectionHandler<AssetResponse, SectionValues> {

    type = 'form';
    icon = 'microchip';
    bulk = false;
    readonly = true;

    title = this.translate('TITLE');
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string,
    ) {}

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.ASSET.LINKED_DEVICES.${key}`, values);
    }

    applyUpdate(entity: AssetResponse, _payload: AssetUpdateRequest): Promise<AssetResponse> {
        return Promise.resolve(entity);
    }

    mapEntityToEditor(entity: AssetResponse): Promise<SectionValues> {
        const values: SectionValues = {};
        (entity.devices || []).forEach((device, i) => {
            values[`device_${i}`] = device.name || device.id;
        });
        return Promise.resolve(values);
    }

    mapEditorToEntity(entity: AssetUpdateRequest, _values: SectionValues): Promise<AssetUpdateRequest> {
        return Promise.resolve(entity);
    }

    async getFields(entity: AssetResponse): Promise<FormBuilderField[]> {
        const devices: AssetDevice[] = entity?.devices || [];
        if (!devices.length) {
            return [{ ...TextField('none', this.translate('FIELDS.DEVICES'), false, 0, 200), readonly: true, placeholder: this.translate('FIELDS.NO_DEVICES') }];
        }
        return devices.map((device, i) => ({
            ...TextField(`device_${i}`, device.deviceType?.name || this.translate('FIELDS.DEVICE'), true, 0, 200),
            readonly: true,
            getHref: () => `/admin/client/${entity.owner.id}/devices/grid/device/${device.id}`,
        }));
    }
}
